// extracted by mini-css-extract-plugin
export default {"container":"expenses_main_container__RNSmb","content":"expenses_main_content__3m+gP"};